import { Navigate } from "react-router-dom";

const Root = () => {
  const url = "/login";

  return <Navigate to={url} replace />;
};

export default Root;
